// extracted by mini-css-extract-plugin
export default {"title":"ContractDetailPage_title__GoeIa"};